import React, { type FC } from 'react';
import { useConversationHistory } from './hooks/useConversationHistory';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spinner } from '@placer-ui/components';
import { PiTitle } from 'features/pi/view/uiManager/titles/pi-title';
import styles from './assistant-history-panel.module.scss';
import { HistoryItem } from 'features/pi/view/uiManager/history-item/history-item';

export const AssistantHistoryPanel: FC = () => {
    const { conversations, hasMore, loadMore, removeConversation } = useConversationHistory();
    return (
        <div className={styles.container}>
            <PiTitle text={'Recent Conversations'} additionalClassName={styles.piTitle} />
            <div id="history-items" data-testid="scroller">
                <InfiniteScroll
                    next={loadMore}
                    hasMore={hasMore}
                    loader={<Spinner variant={'brand'} />}
                    scrollableTarget={'history-items'}
                    dataLength={conversations.length}
                    className={styles.historyItemList}
                >
                    {conversations.map((conversation) => {
                        return (
                            <HistoryItem
                                key={conversation.getId()}
                                conversation={conversation}
                                removeConversation={removeConversation}
                            />
                        );
                    })}
                </InfiniteScroll>
            </div>
        </div>
    );
};
